import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              <span role="img" aria-label="code">
                ⛱️{" "}
              </span>
              I fell in love with programming and I have at least learnt
              something, I think…{" "}
              <span role="img" aria-label="person">
                🤷‍♂️
              </span>
              <br />
              <br />
              <span role="img" aria-label="code">
                👩🏻‍💻{" "}
              </span>
              I am fluent in classics like
              <i>
                {" "}
                <b className="purple"> Javascript and SQL. </b>{" "}
              </i>
              <br />
              <br />
              <span role="img" aria-label="code">
                🎯{" "}
              </span>
              Interested in{" "}
              <b className="purple">
                Open Source, Cloud Technology, Blockchain and AI
              </b>
              .
              <br />
              <br />
              <span role="img" aria-label="code">
                🔤{" "}
              </span>
              My field of interests are{" "}
              <b className="purple">Exploring Latest Technologies</b> and{" "}
              <b className="purple">Developing Useful Web Apps</b>.
              <br />
              <br />
              <span role="img" aria-label="love">
                ❤️{" "}
              </span>
              Love <b className="purple">designing UI/UX</b> for applications
              and creating interesting web apps.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/lata-clabs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/lata-sharma-104927101/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/liv.1110/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
